import { render, staticRenderFns } from "./IngressEgressRuleConfigure.vue?vue&type=template&id=cf602054&scoped=true&"
import script from "./IngressEgressRuleConfigure.vue?vue&type=script&lang=js&"
export * from "./IngressEgressRuleConfigure.vue?vue&type=script&lang=js&"
import style0 from "./IngressEgressRuleConfigure.vue?vue&type=style&index=0&id=cf602054&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf602054",
  null
  
)

export default component.exports